const offsetPanzoneContainer = {x : - 60, y : -47 }
export default offsetPanzoneContainer;